import React from 'react';

import {DefaultContext} from '../../utils/types';
import {ClaimStatus, ShiftClaimContextState} from '../types/shiftClaim';

export const initialState: ShiftClaimContextState = {
  shifts: [],
  claimedIds: [],
  rejectedIds: [],
  claimingId: null,
  rejectingId: null,
  fetchStatus: ClaimStatus.Loading,
};

const defaultVal: DefaultContext<ShiftClaimContextState> = {
  state: initialState,
  dispatch: null,
};

export const ShiftClaimContext = React.createContext(defaultVal);
